var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networking-layout",staticStyle:{"background-color":"#ffffff","min-height":"100vh","font-family":"'Poppins', sans-serif"}},[_c('Navbar',{attrs:{"show-nav":true}}),_c('main',{staticClass:"networking-layout__main",attrs:{"id":"main-content","role":"main"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }